import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fetchConsultationAppointments, scheduleAppointment } from "../../api/consultationHelper";
import { getUserId, getAccesstoken, getUserDetails } from "../../utils/auth";
import Modal from "../Shared/Modal";
import { Link } from "react-router-dom";


const ConsultationAppointment = () => {
  const userDetails = getUserDetails();
  const userAddress = userDetails?.address || {};

  const [appointments, setAppointments] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [bookingConfirmed, setBookingConfirmed] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  
  const [fullName, setFullName] = useState(userDetails ? `${userDetails.first_name} ${userDetails.last_name}` : '');
  const [streetAddress, setStreetAddress] = useState(userAddress?.street_address || '');
  const [pincode, setPincode] = useState(userAddress?.pincode || '');
  const [state, setState] = useState(userAddress?.state || '');

  const userId = getUserId();
  const token = getAccesstoken();

  
  useEffect(() => {
    const fetchAppointments = async () => {
      const data = await fetchConsultationAppointments(userId, token);
      if (data) setAppointments(data);
    };
    fetchAppointments();
  }, [userId, token]);


  const handleSchedule = async () => {
    if (!selectedAppointment || !selectedDate) return;
  
    setIsProcessing(true);
    try {
      await scheduleAppointment(selectedAppointment.id, userId, selectedDate.toISOString(),selectedAppointment.product_name, token);
  
      // Update the appointment status dynamically
      setAppointments((prevAppointments) =>
        prevAppointments.map((appointment) =>
          appointment.id === selectedAppointment.id
            ? { ...appointment, status: "Scheduled" }
            : appointment
        )
      );
  
      setBookingConfirmed(true);
      setSelectedAppointment(null);
      setSelectedDate(null);
  
      // Close the Bootstrap modal manually
      const modalElement = document.getElementById("scheduleModal");
      if (modalElement) {
        const bsModal = window.bootstrap.Modal.getInstance(modalElement);
        if (bsModal) bsModal.hide();
      }
  
      // Ensure backdrop is removed
      setTimeout(() => {
        document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }, 500);
  
    } catch (error) {
      alert("Failed to schedule appointment. Please try again.");
    }finally {
      setIsProcessing(false); // Stop processing after completion
    }
  };
  
  const handleCloseModal = () => {
    setBookingConfirmed(false);
  
    // Ensure backdrop is removed
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  };
  
  // useEffect(() => {
  //   if (bookingConfirmed) {
  //     const timer = setTimeout(() => {
  //       handleCloseModal();
  //       window.location.reload();
  //     }, 5000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [bookingConfirmed]);

  useEffect(() => {
    if (bookingConfirmed) {
      const timer = setTimeout(() => {
        handleCloseModal();
  
        // Instead of refreshing, update the appointment status locally
        setAppointments((prevAppointments) =>
          prevAppointments.map((appointment) =>
            appointment.id === selectedAppointment?.id
              ? { ...appointment, status: "Scheduled", scheduled_at: selectedDate }
              : appointment
          )
        );
  
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [bookingConfirmed, selectedAppointment, selectedDate]);
  
  
  
  return (
    <div className="dashboard_grey_section">
      <h1 className="font-lg mb-4">Appointment Booking</h1>
      <div className="row">
      {appointments.length > 0 ? (
        appointments.map((appointment) => (
          <div className="col-md-4 mb-4" key={appointment.id}>
            <div className="card shadow-sm border-0">
              <div className="card-header text-white" style={{ backgroundColor: "var(--theme-color)" }}>
                <h3 className="mb-0">{appointment.product_name}</h3>
              </div>
              <div className="card-body">
  <p><strong>Status:</strong> {appointment.status}</p>

  {(appointment.status.toLowerCase() === "scheduled" || appointment.status.toLowerCase() === "confirmed") && 
   appointment.scheduled_at && (
    <>
      <p><strong>Scheduled At:</strong> {new Date(appointment.scheduled_at).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      })}</p>
      {appointment.status.toLowerCase() === "confirmed" && appointment.meet_link && (
        <div><p>
          <strong>Meet Link:</strong>{" "}
          <a 
            href={appointment.meet_link} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Join Meeting
          </a>
        </p>
        <button
      className="btn text-white w-100"
      style={{ backgroundColor: "var(--theme-color1)" }}
      data-bs-toggle="modal"
      data-bs-target="#scheduleModal"
      onClick={() => setSelectedAppointment(appointment)}
    >
      Reschedule
    </button>
        </div>
        
      )}
    </>
  )}

  {appointment.status.toLowerCase() === "rejected" && appointment.reason && (
    <div>
    <p>
      <strong>Reason:</strong>{" "}
      {appointment.reason}
    </p>
    <p>Please reschedule your appointment</p>
    </div>
  )}

  {(appointment.status.toLowerCase() === "pending" || appointment.status.toLowerCase() === "rejected") && (
    <button
      className="btn text-white w-100"
      style={{ backgroundColor: "var(--theme-color1)" }}
      data-bs-toggle="modal"
      data-bs-target="#scheduleModal"
      onClick={() => setSelectedAppointment(appointment)}
    >
      Schedule
    </button>
  )}
</div>


            </div>
          </div>
        ))
      ) : (
        <p>
          This is exclusively available with add-on services purchase.  
          <Link to="/cart">Click here to purchase</Link>.
        </p>
      )}
      </div>

      {/* Bootstrap Modal for Scheduling */}
      <div className="modal fade" id="scheduleModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Select Date & Time</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-column align-items-center">
                <label className="mb-2"><strong>Choose Date & Time:</strong></label>
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  showTimeSelect
                  dateFormat="MMMM d, yyyy h:mm aa"
                  className="form-control"
                  minDate={new Date()}
                  popperPlacement="top-start"
                />
              </div>

              {selectedAppointment && selectedAppointment.product_name === "Screening for Pre-diabetes" && (
                <div className="mt-4">
                  <h6 className="mb-3">Address Details for Blood Sample Collection</h6>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={fullName} 
                        onChange={(e) => setFullName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Street Address</label>
                    <textarea
                      className="form-control"
                      value={streetAddress} 
                      onChange={(e) => setStreetAddress(e.target.value)}
                      required
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">State</label>
                      <input
                        type="text"
                        className="form-control"
                        value={state} 
                        onChange={(e) => setState(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Pincode</label>
                      <input
                        type="text"
                        className="form-control"
                        value={pincode} 
                        onChange={(e) => setPincode(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button
                type="button"
                className="btn text-white"
                style={{ backgroundColor: "var(--theme-color1)" }}
                onClick={handleSchedule}
              >
                 {isProcessing ? (
            <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Processing...
            </>
        ) : (
            "Confirm Appointment"
        )}
              </button>
            </div>
          </div>
        </div>
      </div>
      {bookingConfirmed && (
  <Modal
    title="Booking Confirmed!"
    modalType="success"
    bodyText="Your appointment has been scheduled successfully."
    modalId="bookingModal"
    onClose={() => {
      setBookingConfirmed(false);
      // Remove any lingering backdrop
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
      // Reset any inline styles added to body
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }}
  />
)}

    </div>
  );
};

export default ConsultationAppointment;
